import React from "react";
import PropTypes from "prop-types";
import FormInput from "Common/Custom/FormInput";
import FormSelect from "Common/Custom/FormSelect";
import FormDatePicker from "Common/Custom/ReactFlatpickr";
import RoomFacilitiesCheckboxGroup from "./RoomFacilitiesCheckboxGroup";

/**
 * SearchRoomForm
 * Renders the filter row (date, status, floor, search) and the room card grid.
 * Field types are driven by HousekeepingFields.json → searchdata array.
 */
const SearchRoomForm = ({
   fields = [],
   values = {},
   errors = {},
   handleChange = () => { },
   FlorListOptions = [],
   setValues,
   RoomOptions = [],
}) => {
   return (
      <>
         <div className="col-12 mb-3">
            <h6 className="mb-1">Search Room</h6>
            <small className="text-muted">Filter rooms by date, status, or floor</small>
         </div>

         {fields.map((field) => {
            /* ── SELECT ─────────────────────────────────────────────── */
            if (field.type === "select") {
               // Floor dropdown is populated from the API; others use JSON options
               const options =
                  field.name === "floor"
                     ? FlorListOptions.map((opt) => ({
                        label: opt.floor_name,
                        value: opt.floor_name,
                     }))
                     : field.options || [];

               return (
                  <FormSelect
                     key={field.name}
                     field={field}
                     value={values[field.name] ?? ""}
                     handleChange={handleChange}
                     options={options}
                     error={errors[field.name]}
                  />
               );
            }

            /* ── DATE ───────────────────────────────────────────────── */
            if (field.type === "date") {
               return (
                  <FormDatePicker
                     key={field.name}
                     field={{
                        ...field,
                        lableHide: true
                     }}
                     value={values[field.name] ?? ""}
                     handleChange={handleChange}
                     error={errors[field.name]}
                     mode="date"
                  />
               );
            }

            /* ── CHECKBOX (room card grid) ───────────────────────────── */
            if (field.type === "checkbox") {
               return (
                  <RoomFacilitiesCheckboxGroup
                     key={field.name}
                     field={field}
                     values={values}
                     setValues={setValues}
                     facilityOptions={RoomOptions}
                     handleChange={handleChange}
                     errors={errors}
                  />
               );
            }

            /* ── DEFAULT TEXT INPUT ──────────────────────────────────── */
            return (
               <FormInput
                  key={field.name}
                  field={{
                     ...field,
                     lableHide: true
                  }}
                  value={values[field.name] ?? ""}
                  handleChange={handleChange}
                  error={errors[field.name]}
               />
            );
         })}
      </>
   );
};

SearchRoomForm.propTypes = {
   fields: PropTypes.arrayOf(
      PropTypes.shape({
         name: PropTypes.string.isRequired,
         label: PropTypes.string,
         type: PropTypes.oneOf(["text", "select", "date", "number", "checkbox"]),
         options: PropTypes.array,
      })
   ),
   values: PropTypes.object,
   errors: PropTypes.object,
   handleChange: PropTypes.func,
   FlorListOptions: PropTypes.arrayOf(PropTypes.shape({ floor_name: PropTypes.string })),
   setValues: PropTypes.func,
   RoomOptions: PropTypes.array,
};

export default SearchRoomForm;
